<template>
  <main-layout
    customControls
    controlsBg="light"
    :hasControlsBar="true"
    :breadcrumb="getBreadcrumb">
    <div slot="custom-controls-top">
      <div class="controls__filters note">
        <health-week-control
          v-model="selectedDay"
          v-if="gramsKiloMode"
          v-on:input="requestDataInEmit"
        />
        <health-explorer-controls-user-select
          v-has-feature="'NutritionalPlanUser'"
          v-model="selectedUser"
          v-on:click="requestData"
          v-show="!disableUserSelect"
          v-on:hidden="hiddeComp"
        />
      </div>
    </div>
    <div class="container">
      <div class="header">
        <div class="header__title">
          <h1
            class="flex">
            {{ $t('health.nutritionalPlan.menu') }}
          </h1>
        </div>
      </div>
      <div v-if="hasPlan">
        <grams-kilo-mode-plan
          :mealTypes="mealTypes"
          :selectedDay="selectedDay"
          :weekPlan="weekPlan"
          :meals="meals"
          v-if="gramsKiloMode"
        />
        <free-mode-plan
          :mealTypes="mealTypes"
          :meals="meals"
          v-else/>
      </div>
      <div v-else>
        <grid-row  class="margin-top-xl" >
          <grid-col col-size="4">
            {{$t('health.userProfile.nutritionalPlanExpired')}}
          </grid-col>
        </grid-row>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import HealthExplorerControlsUserSelect from 'BRAND/components/explorer/HealthExplorerControlsUserSelect';
import HealthWeekControl from 'BRAND/components/explorer/HealthWeekControl';
import Chevron from '@/components/shared/Chevron';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import nutritionApi from 'BRAND/api/nutritionPlan';
import WeekPlanTable from 'BRAND/components/nutritionPlan/WeekPlanTable';
import BtnPill from '@/components/shared/buttons/BtnPill';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {faFileDownload} from '@fortawesome/pro-solid-svg-icons';
import MealTypeDetails from 'BRAND/components/nutritionPlan/MealTypeDetails';
import VueHtml2pdf from 'vue-html2pdf';
import MealCardsGroup from 'BRAND/components/nutritionPlan/MealCardsGroup';
import GramsKiloModePlan from 'BRAND/components/nutritionPlan/GramsKiloModePlan';
import FreeModePlan from '../../components/nutritionPlan/FreeModePlan.vue';

export default {
  name: 'NutritionalPlan',
  components: {
    FreeModePlan,
    GramsKiloModePlan,
    MealCardsGroup,
    MainLayout,
    HealthExplorerControlsUserSelect,
    HealthWeekControl,
    Chevron,
    GridCol,
    GridRow,
    WeekPlanTable,
    BtnPill,
    FontAwesomeIcon,
    MealTypeDetails,
    VueHtml2pdf
  },
  data () {
    return {
      selectedUser: null,
      disableUserSelect: false,
      selectedDay: null,
      hasPlan: false,
      icon: {
        file: faFileDownload
      },
      mealTypes: [
        'Desayuno',
        'Almuerzo',
        'Comida',
        'Merienda',
        'Cena'
      ],
      weekDays: [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday'
      ],
      weekPlan: [],
      meals: [],
      gramsKiloMode: false,
      colorOptions: [
        {label: this.$t('health.nutritionalPlan.colors.white'), value: 0, id: 0, color: '#f1f1f1'},
        {label: this.$t('health.nutritionalPlan.colors.green'), value: 1, id: 1, color: '#4e9d26'},
        {label: this.$t('health.nutritionalPlan.colors.yellow'), value: 2, id: 2, color: '#fcca2d'},
        {label: this.$t('health.nutritionalPlan.colors.red'), value: 3, id: 3, color: '#ff4f4f'},
        {label: this.$t('health.nutritionalPlan.colors.purple'), value: 4, id: 4, color: '#c389ff'}
      ]
    };
  },
  watch: {
    selectedUser: {
      handler: function () {
        this.checkNutritionalPlanExpiration();
      }
    },
    selectedDay: {
      handler: function () {
        if (this.hasPlan) {
          this.requestData();
        }
      }
    }
  },
  created () {
    this.selectedDay = new Date();
    const daysToSubstract = this.selectedDay.getDay() === 0 ? 7 : this.selectedDay.getDay();
    const newDay = this.selectedDay.getDate() - daysToSubstract + 1;
    this.selectedDay = this.selectedDay.setDate(newDay);
    this.checkNutritionalPlanExpiration();
  },
  computed: {
    getBreadcrumb () {
      return [
        {
          name: this.$t('health.nutritionalPlan.menu'),
          link: '/nutritionalPlan',
          disabled: true
        }
      ];
    }
  },
  methods: {
    requestData () {
      if (this.selectedUser) {
        nutritionApi.getNutritionPlanMode(this, this.selectedUser).then(data => {
          this.gramsKiloMode = data === 'gramsKilo';
          if (this.gramsKiloMode) {
            nutritionApi.getWeekCalendar(this, this.selectedUser, this.selectedDay).then(data => {
              this.weekPlan = [];
              const items = data.items;
              this.mealTypes.forEach((value, index) => {
                const item = items.find(item => item.type === value);
                if (item) {
                  const existingWeekItems = item.dateValues;
                  let newItem = {
                    id: index,
                    type: value
                  };
                  for (let i = 0; i < 7; i++) {
                    const weekDate = new Date(this.selectedDay);
                    weekDate.setDate(weekDate.getDate() + i);
                    const foundItem = existingWeekItems.find(weekItem => {
                      return new Date(weekItem.timestamp).getDate() === weekDate.getDate();
                    });
                    const weekDayText = this.weekDays[weekDate.getDay()];
                    let intensity;
                    if (!foundItem) {
                      intensity = 0;
                    } else {
                      intensity = foundItem.intensity;
                    }
                    newItem[weekDayText] = intensity;
                  }
                  this.weekPlan.push(newItem);
                } else {
                  const newItem = {
                    id: index,
                    type: value,
                    monday: 0,
                    tuesday: 0,
                    wednesday: 0,
                    thursday: 0,
                    friday: 0,
                    saturday: 0,
                    sunday: 0
                  };
                  this.weekPlan.push(newItem);
                }
              });
            });
          }
        });
        nutritionApi.getPlans(this, this.selectedUser, null, true, false).then((data) => {
          this.meals = data.map(meal => {
            const colorIndex = Math.trunc(meal.carbsFactor / 0.5);
            return {
              ...meal,
              color: colorIndex < this.colorOptions.length - 1 ? this.colorOptions[colorIndex].color : this.colorOptions[this.colorOptions.length - 1].color
            };
          });
        });
      }
    },
    checkNutritionalPlanExpiration () {
      if (this.selectedUser) {
        nutritionApi.hasNutritionPlan(this, this.selectedUser).then(data => {
          this.hasPlan = data.body;
          if (this.hasPlan) {
            this.requestData();
          }
        });
      }
    },
    hiddeComp () {
      this.disableUserSelect = !this.disableUserSelect;
    },
    requestDataInEmit () {
      if (this.disableUserSelect) {
        this.checkNutritionalPlanExpiration();
      }
    },
    getMealsByType (mealType) {
      return this.meals.filter(meal => meal.type === mealType);
    },
    generateReport () {
      this.$refs.html2Pdf.generatePdf();
    },
    isCurrentWeekDate () {
      const newDate = new Date();
      let selectedDate = new Date(this.selectedDay);
      selectedDate.setHours(0, 0, 0, 0);
      newDate.setHours(0, 0, 0, 0);

      const isFuture = this.selectedDay ? newDate.getTime() < selectedDate.getTime() : false;
      const sevenDaysMillis = 604800000;
      const minusSevenDaysDate = new Date(newDate.getTime() - sevenDaysMillis);
      const isPastWeek = minusSevenDaysDate.getTime() >= selectedDate.getTime();
      return !isFuture && !isPastWeek;
    }
  }
};

</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/variables";

.chart-title {
  display: flex;
  font-size: 1.2rem;
  margin-bottom: $sp-margin-small;
  text-align: center;
  align-items: center
}

.aligned {
  margin: auto;
  width: 90%;
}

.container {
  padding-top: $sp-margin;
  padding-bottom: $sp-margin;
  flex-grow: 1;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  justify-content: space-between;

  &__title {
    margin-bottom: $sp-margin;
    @media (min-width: $breakpoint) {
      display: flex;
      h1 {
        margin-bottom: 0;
        margin-right: $sp-margin;
        padding-right: $sp-margin;
      }
    }
  }
}
.right{
  margin-left: 80%;

}

img {
  width: 170px;
  height: auto;
}

</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/nutritionalPlan/NutritionalPlan.vue